import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { TestimonialCard } from "@/components/TestimonialCard";

export function TestimonialsSection({ testimonials }) {
  if (!testimonials.length) return null;
  return (
    <section className="py-20 md:py-24 bg-navy-band border-y border-navy-100" data-testid="home-testimonials">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between gap-6 flex-wrap mb-12">
          <div className="max-w-3xl">
            <p className="overline mb-3">Customer stories</p>
            <h2 className="h-display text-3xl md:text-4xl">What changes when clients can see the timeline.</h2>
          </div>
          <Link to="/customers" className="btn-ghost" data-testid="home-testimonials-more">
            All stories <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {testimonials.slice(0, 3).map((t) => <TestimonialCard key={t.id} t={t} compact />)}
        </div>
      </div>
    </section>
  );
}
